module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"firstName":"First name","lastName":"Last name","phone":"Phone number","invite":"Accept","cancel":"Cancel","resume":"Resume","sizeWarning":"The resume should not be larger than","searchTitle":"Existing candidates","candidateNotFound":"No such candidate was found. A new candidate will be created"}}')
  delete Component.options._Ctor
}
